import { apiCall } from './apiClient';
import type { RaAttempt, RaContent, RaCurrent, RaResult, RaSavedAnswer, RaContacts, RaContactReportInput } from '../ra-training/types';

async function request<T>(path: string, method: 'GET' | 'POST' | 'PUT' = 'GET', body?: unknown): Promise<T> {
  const response = await apiCall<T>(`/api/ra-training${path}`, method, body, { timeoutMs: 30_000, retries: 0 });
  if (!response.success || response.data == null) {
    throw Object.assign(new Error(response.error || 'Could not load Warfighter Training. Please retry.'), {
      error_code: response.error_code,
    });
  }
  return response.data;
}

export const getRaTrainingContent = () => request<RaContent>('/content');
export const getRaTrainingCurrent = () => request<RaCurrent>('/current');
export const getRaContacts = () => request<RaContacts>('/contacts');
export const reportRaContact = (body: RaContactReportInput) => request<{ id: string; status: string }>('/contact-reports', 'POST', body);
export const startRaTraining = (contentVersion: string) => request<RaAttempt>('/start', 'POST', {
  content_version: contentVersion, acknowledged: true,
});
export const saveRaTrainingAnswer = (attemptId: string, questionId: string, optionId: string) =>
  request<RaSavedAnswer>(`/attempts/${encodeURIComponent(attemptId)}/answers/${encodeURIComponent(questionId)}`, 'PUT', {
    option_id: optionId,
  });
export const submitRaTraining = (attemptId: string) =>
  request<RaResult>(`/attempts/${encodeURIComponent(attemptId)}/submit`, 'POST', {});
export const retryRaTraining = (attemptId: string, contentVersion: string) =>
  request<RaAttempt>(`/attempts/${encodeURIComponent(attemptId)}/retry`, 'POST', {
    content_version: contentVersion, acknowledged: true,
  });
